import styled, { css } from 'styled-components';
import { ifProp, theme, palette } from 'styled-tools';

interface Props {
  required?: boolean;
  color?: string;
  fontStyle?: string;
  isUnderLine?: boolean;
  wordBreak?: boolean;
  cursor?: string;
}

export const StyledLabel = styled.label<Props>`
  word-break: break-word;
  
  ${(props) =>
    props.required
      ? css`
          &::after {
            content: '*';
            visibility: ${ifProp('required', 'unset', 'hidden')};
            color: ${palette('blue_900')};
          }
        `
      : null}
  ${(props) =>
    props.color
      ? css`
          color: ${palette(props.color)};
        `
      : null}
    ${(props) =>
    props.fontStyle
      ? css`
          ${theme(`fontStyle.${props.fontStyle}`)}
        `
      : null}
    ${(props) =>
    props.isUnderLine
      ? css`
          text-decoration: underline;
        `
      : null}
    ${(props) =>
    props.wordBreak
      ? css`
          word-break: keep-all;
        `
      : null}
    ${(props) =>
    props.cursor
      ? css`
          cursor: ${props.cursor};
        `
      : null}
`;
